import {
    MIN_PASSWORD_LENGTH,
    ERR_MESSAGE_MIN_PASSWORD_LENGTH,
    ERR_MESSAGE_PASSWORD_DONT_MATCH
} from './constants';

export default function validate(formProps) {
    const errors = {};

    if (!formProps.name) {
        errors.name = 'Name is required!';
    }

    if (!formProps.email) {
        errors.email = 'Email is required!';
    }

    if (
        formProps.email &&
        !formProps.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)
    ) {
        errors.email = 'Please enter a valid email address';
    }

    if (
        formProps.new_password &&
        formProps.new_password.length < MIN_PASSWORD_LENGTH
    ) {
        errors.new_password = ERR_MESSAGE_MIN_PASSWORD_LENGTH;
    }

    if (
        formProps.new_password_repeat &&
        formProps.new_password_repeat.length < MIN_PASSWORD_LENGTH
    ) {
        errors.new_password_repeat = ERR_MESSAGE_MIN_PASSWORD_LENGTH;
    }

    if (
        formProps.new_password &&
        formProps.new_password_repeat &&
        formProps.new_password !== formProps.new_password_repeat
    ) {
        errors.new_password_repeat = ERR_MESSAGE_PASSWORD_DONT_MATCH;
    }

    return errors;
}



// WEBPACK FOOTER //
// ./src/containers/myaccount/forms/validation.js